import vue from '@/main';

const routes = {
  'edit-basic-profile-data': {
    key: 'basic_information',
    label: vue.$gettext('Basic information'),
    editRoute: `edit-basic-profile-data`,
    optional: false,
    order: 0
  },
  'edit-work-experience': {
    key: 'work_experience',
    label: vue.$gettext('Work experience'),
    editRoute: `edit-work-experience`,
    optional: false,
    order: 1
  },
  'edit-education': {
    key: 'education',
    label: vue.$gettext('Education'),
    editRoute: `edit-education`,
    optional: false,
    order: 2
  },
  'edit-projects': {
    key: 'projects',
    label: vue.$gettext('Projects'),
    editRoute: `edit-projects`,
    optional: true,
    order: 3
  },
  'edit-trainings': {
    key: 'trainings',
    label: vue.$gettext('Trainings and certificates'),
    editRoute: `edit-trainings`,
    optional: true,
    order: 4
  },
  'edit-skills': {
    key: 'skills',
    label: vue.$gettext('Skills'),
    editRoute: `edit-skills`,
    optional: true,
    order: 5
  },
  'edit-languages': {
    key: 'languages',
    label: vue.$gettext('Languages'),
    editRoute: `edit-languages`,
    optional: true,
    order: 6
  },
  'edit-motivators': {
    key: 'motivators',
    label: vue.$gettext('Motivators'),
    editRoute: `edit-motivators`,
    optional: true,
    order: 7
  }
};

const orderRoutes = Object.keys(routes).sort((a, b) => a.order - b.order);

function getUncompletedRequiredPartRouteName(profileCompleteness) {
  for (let routeName of orderRoutes) {
    let route = routes[routeName];
    if (!route.optional && profileCompleteness[route['key']] < 75) {
      return routes[routeName].editRoute;
    }
  }
}

export default {routes, orderRoutes, getUncompletedRequiredPartRouteName};
